// @flow

import _ from 'lodash';

import ArrayUtils from '../../utils/ArrayUtils';

import ApiObject from '../ApiObject';
import ProductOptionValue from './ProductOptionValue';

import { getLocalizedData } from '../../utils/CatalogUtils'

export default class ProductOption extends ApiObject {

  id: string = '';

  name: string = '';

  localizedNames: Array<> = [];

  image: string = '';

  quantityMin: number = 0;

  quantityMax: number = 0;

  values: Array<ProductOptionValue> = [];

  set name(name) {
    this._name = name
  }

  get name() {
    return getLocalizedData(this.localizedNames) || this._name || ''
  }

  postJsonAssignation(data: Object) {
    this.values = [];
    _.each(data.values, (valueData: Object) => {
      const productOptionValue: ProductOptionValue = new ProductOptionValue();
      productOptionValue.fromJson(valueData);
      this.values.push(productOptionValue);
    });
  }

  updateProductOptionValue(productOptionValueToUpdate: ProductOptionValue) {
    this.values = ArrayUtils.updateObject(this.values, productOptionValueToUpdate, (productOptionValue: ProductOptionValue) => {
      return productOptionValueToUpdate.id === productOptionValue.id;
    });
  }

  //
  //
  //

  isRequired(): boolean {
    return this.quantityMin >= 1;
  }

  //
  // Validation
  //

  /**
   * Verify that the object is correct
   */
  isValid(): boolean {
    // TODO: update
    return this.validateName() && this.validateQuantity() && this.validateValues();
  }

  validateName(): boolean {
    if (_.isEmpty(this.localizedNames)) {
      return false
    }

    let isValid = false

    _.forEach(this.localizedNames, localizedName => {
      if (!_.isEmpty(localizedName.text)) {
        isValid = true
      }
    })

    return isValid
  }

  validateQuantity(): boolean {
    return this.quantityMin >= 0 && this.quantityMax >= 1 && this.quantityMin <= this.quantityMax;
  }

  validateValues(): boolean {
    return this.values.length >= this.quantityMin;
  }

  static validationErrors = {
    name: 'Le nom ne peut être vide',
    quantity: 'La quantité est invalide',
    values: 'Le nombre de choix offerts est invalide. Il doit être au moins égal a la quantité minimum.'
  };

  getValidationErrors(): Object {
    const validationErrors = ProductOption.validationErrors;
    const errors = {};

    if (!this.validateName()) {
      errors.name = validationErrors.name;
    }

    if (!this.validateQuantity()) {
      errors.quantity = validationErrors.quantity;
    }

    if (!this.validateValues()) {
      errors.values = validationErrors.values;
    }

    return errors;
  }

  //
  //
  //

  addValue(value: ProductOptionValue) {
    this.values.push(value);
  }

  updateValue(value: ProductOptionValue) {
    this.values = ArrayUtils.updateObject(this.values, value, { id: value.id });
  }

  deleteValue(value: ProductOptionValue) {
    this.values = ArrayUtils.deleteObject(this.values, { id: value.id });
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/menu/ProductOption.js